import { getConfig } from "@edx/frontend-platform";

export const isSpeechCraftMFE = () => getConfig().PLATFORM_NAME === "speechcraft";

const useIsSpeechCraftMFE = () => isSpeechCraftMFE();

export default useIsSpeechCraftMFE;
